import {
  ChatBubbleLeftRightIcon,
  LightBulbIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { getSupportLinks, getSupportBaseUrl, getOrgId } from '../../config/support';

const ACTIONS = [
  {
    key: 'help' as const,
    title: 'Help & support',
    description: 'Browse help articles or chat with the BirdMan assistant.',
    icon: ChatBubbleLeftRightIcon,
    accent: 'text-sky-600',
  },
  {
    key: 'suggest' as const,
    title: 'Suggest a feature',
    description: 'Tell us what would make BirdMan better for your aviary.',
    icon: LightBulbIcon,
    accent: 'text-amber-600',
  },
  {
    key: 'report' as const,
    title: 'Report a problem',
    description: 'Something not working? Send us the details so we can help.',
    icon: ExclamationTriangleIcon,
    accent: 'text-rose-600',
  },
];

export default function SupportSettings() {
  const links = getSupportLinks();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="mb-1 text-lg font-medium leading-6 text-slate-900">Help &amp; Support</h3>
        <p className="text-sm text-slate-500">
          Get help, suggest features, or report a problem. Links open the BirdMan
          support portal in a new tab.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {ACTIONS.map((action) => (
          <a
            key={action.key}
            href={links[action.key]}
            target="_blank"
            rel="noreferrer"
            className="flex flex-col rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-sky-300 hover:shadow"
          >
            <action.icon className={`h-6 w-6 ${action.accent}`} aria-hidden="true" />
            <span className="mt-3 text-base font-semibold text-slate-900">{action.title}</span>
            <span className="mt-1 flex-1 text-sm text-slate-500">{action.description}</span>
            <span className="mt-3 text-sm font-medium text-sky-600">Open →</span>
          </a>
        ))}
      </div>

      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 text-xs text-slate-500">
        <p>
          Support portal: <code>{getSupportBaseUrl()}</code>
        </p>
        <p className="mt-1">
          Organisation (solutionId): <code>{getOrgId()}</code>
        </p>
      </div>
    </div>
  );
}
